import { Position } from '@xyflow/react';
import { ERFElement } from '../../../enums';
import { M_FLOW_HEX } from '../../../constants';
import { createPortCode } from '../../../utils';
export const DOT_MATERIAL_CONFIG = {
    type: ERFElement.DotMaterial,
    templates: [
        {
            code: 'single',
            ports: [
                {
                    id: createPortCode('target', 'material'),
                    type: 'target',
                    name: 'Вход',
                    position: Position.Left,
                    style: { top: 7, left: 0, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                {
                    id: createPortCode('source', 'material'),
                    type: 'source',
                    name: 'Выход',
                    position: Position.Right,
                    style: { top: 7, right: 0, background: M_FLOW_HEX },
                    connectionCount: 1
                }
            ]
        },
        {
            code: 'multi',
            ports: [
                {
                    id: createPortCode('target', 'material'), // Входные материальные потоки
                    type: 'target',
                    name: 'Вход',
                    position: Position.Left,
                    style: { top: 7, left: 0, background: M_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                },
                {
                    id: createPortCode('source', 'material'), // Выходные материальные потоки
                    type: 'source',
                    name: 'Выход',
                    position: Position.Right,
                    style: { top: 7, right: 0, background: M_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                }
            ]
        }
    ]
};
//# sourceMappingURL=RFDotMaterialNode.config.js.map